import axios, { AxiosResponse } from 'axios';
import { BestMixFeed } from 'views/feed-management/features/best-mix-feeds/types/best-mix-feed.type';
import {
  CustomField as EditCustomField,
  UpdateBestMixFeedDetailsInput,
} from 'views/feed-management/features/best-mix-feeds/types/update-best-mix-feed-details-input.type';
import { UpdateBestMixFeedStatusInput } from 'views/feed-management/features/best-mix-feeds/types/update-best-mix-feed-status-input.type';

// PUT
// Set company details for product.
// /ewosapi/v1/bestmix/product/{code}/details
export const putFeedManagementBestMixFeedDetails = async (
  code: string,
  request: UpdateBestMixFeedDetailsInput
): Promise<BestMixFeed> => {
  const res = await axios.put<BestMixFeed>(`/ewosapi/v1/bestmix/product/${code}/details`, request);
  return res.data;
};

// PUT
// /ewosapi/v1/bestmix/company/{globalCompanyId}/product/manage
export const putBestMixFeedStatus = async (globalCompanyId: string, request: UpdateBestMixFeedStatusInput): Promise<AxiosResponse> => {
  return await axios.put<AxiosResponse>(`/ewosapi/v1/bestmix/company/${globalCompanyId}/product/manage`, request);
};

// PUT
// /ewosapi/v1/bestmix/product/{productCode}/custom-field
export const putBestMixCustomField = async (productCode: string, request: EditCustomField): Promise<AxiosResponse> => {
  return (await axios.put<AxiosResponse>(`ewosapi/v1/bestmix/product/${productCode}/custom-field`, request)).data;
};
